import { render, staticRenderFns } from "./RunningJobs.vue?vue&type=template&id=56da677e&"
import script from "./RunningJobs.vue?vue&type=script&lang=js&"
export * from "./RunningJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports